import React from 'react';
import AdminSenderName from '../../common/chat/timeline/AdminSenderBadge';
import EventChatAvatarNode from '../../common/chat/avatars/EventChatAvatarNode';

// ChatPage.js のコンポーネント外 JSX ヘルパを分離（挙動不変・純粋移動）。

export const resolveAdminSenderDisplayName = (message) =>
  String(
    message?.admin_name ||
      message?.admin_full_name ||
      message?.admin_display_name ||
      message?.admin_username ||
      ''
  ).replace(/\s*[(（](?:Tacticart|Casticart)[)）]\s*$/i, '').trim();

export const renderAdminSenderMeta = (message) => {
  const senderName = resolveAdminSenderDisplayName(message);
  if (!senderName) return null;
  return (
    <span className="message-sender-meta">
      <span className="message-sender"><AdminSenderName name={senderName} /></span>
    </span>
  );
};

export const renderAdminSenderAvatar = (message) => {
  const senderName = resolveAdminSenderDisplayName(message);
  if (!senderName) return null;
  return (
    <EventChatAvatarNode
      role="admin"
      name={senderName}
      picture={message?.admin_profile_picture || ''}
      title={senderName}
      className="chat-avatar"
      initialClassName="chat-avatar-initial"
    />
  );
};
